<template>
    <div>
        <common-content-spacer height="medium" class="invoice-list">
            <common-table>
                <thead>
                    <tr>
                        <th>{{ $t('components.invoices.company_invoices.issue_date') }}</th>
                        <th>{{ $t('components.invoices.company_invoices.name') }}</th>
                        <th>{{ $t('components.invoices.company_invoices.price') }}</th>
                        <th>{{ $t('components.invoices.company_invoices.paid') }}</th>
                        <th>{{ $t('components.invoices.company_invoices.download') }}</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(invoice, index) in invoices" :key="index">
                        <td :data-label="$t('components.invoices.company_invoices.issue_date')">
                            {{ dayjs(invoice.createdAt) }}
                        </td>
                        <td :data-label="$t('components.invoices.company_invoices.name')">{{ invoice.invoiceNumber }}</td>
                        <td :data-label="$t('components.invoices.company_invoices.price')">
                            {{ invoice.totalAmountForPayment }} {{ currency }}
                        </td>
                        <td :data-label="$t('components.invoices.company_invoices.paid')">{{ invoice.paid }} {{ currency }}</td>
                        <td>
                            <common-button
                                :label="$t('components.invoices.company_invoices.download_button')"
                                :isSubmittable="false"
                                size="micro"
                                type="secondary"
                                @click="download(invoice)"
                            ></common-button>
                        </td>
                    </tr>
                </tbody>
            </common-table>
            <div :class="saldo.class">
                {{ $t(saldo.label) }}
                <b>{{ formattedAmount }}</b>
            </div>
        </common-content-spacer>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import FileMixin from 'mixins/FileMixin'

    export default {
        mixins: [FileMixin],

        props: {
            invoices: { type: Array, required: true },
        },

        data() {
            return {
                saldo: {},
            }
        },

        computed: {
            getAmount() {
                return this.invoices.reduce((acc, curr) => {
                    return acc + (curr.totalAmountForPayment - curr.paid)
                }, 0)
            },

            currency() {
                return this.invoices.length > 0 ? this.invoices[0].currency : null
            },

            formattedAmount() {
                if (!this.saldo.amount) return ''
                return `${Math.round(this.saldo.amount)} ${this.currency}`
            },
        },

        methods: {
            dayjs(date) {
                return dayjs(date).format('DD.MM.YYYY')
            },

            download(invoice) {
                this.downloadFile(invoice.s3Path, `${invoice.invoiceNumber}.pdf`)
            },
            getSaldo() {
                this.saldo.amount = Math.abs(this.getAmount)
                if (this.getAmount > 0) {
                    this.saldo.label = 'components.invoices.company_invoices.rest_to_pay'
                } else if (this.getAmount < 0) {
                    this.saldo.label = 'components.invoices.company_invoices.paid_in_advance'
                } else {
                    this.saldo.label = 'components.invoices.company_invoices.all_paid'
                }
                this.saldo.class =
                    this.getAmount <= 0 ? 'invoice-saldo invoice-saldo__prepaid' : 'invoice-saldo invoice-saldo__resto'
            },
        },

        created() {
            this.getSaldo()
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/invoice/_invoice-list.scss';
    @import 'styles/components/invoice/_invoice-saldo.scss';
</style>
